import React from 'react';
import background from '../../assets/lionfish.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoInvasivespecies extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="OCEANS"
        description="Invasive Species"
        paragraph="Marine Invasive Species are animals or algae that have been translocated from their native region. Their lack of natural predators threatens the affected ecosystems."
        background={background}
     />
  
  );
 }
}   

export default InfoInvasivespecies;